import type { CosignatureDocumentType, CosignatureStatus } from "@/core/types";

import type { NoteAction } from "../../types";

export const DocumentTypeMap = {
  note: "Note",
  note_addendum: "Addendum",
} as const satisfies Record<CosignatureDocumentType, string>;

type ActionItem = { id: NoteAction; isDisabled?: boolean; label: string };

const VIEW_ONLY_ACTION_ITEMS_NOTE = [
  { id: "review", label: "View" },
  { id: "cosign", isDisabled: true, label: "Approve & Co-Sign" },
  { id: "reject", isDisabled: true, label: "Reject Note" },
] as const satisfies ActionItem[];

const ALL_ACTION_ITEMS_NOTE = [
  { id: "review", label: "Review" },
  { id: "cosign", label: "Approve & Co-Sign" },
  { id: "reject", label: "Reject Note" },
] as const satisfies ActionItem[];

const VIEW_ONLY_ACTION_ITEMS_ADDENDUM = [
  { id: "review", label: "View" },
  { id: "cosign", isDisabled: true, label: "Approve & Co-Sign" },
  { id: "reject", isDisabled: true, label: "Reject Addendum" },
] as const satisfies ActionItem[];

const ALL_ACTION_ITEMS_ADDENDUM = [
  { id: "review", label: "Review" },
  { id: "cosign", label: "Approve & Co-Sign" },
  { id: "reject", label: "Reject Addendum" },
] as const satisfies ActionItem[];

export const ACTION_ITEMS_BY_DOCUMENT_TYPE = {
  note: {
    pending: ALL_ACTION_ITEMS_NOTE,
    rejected: VIEW_ONLY_ACTION_ITEMS_NOTE,
    resubmitted: ALL_ACTION_ITEMS_NOTE,
    signed: VIEW_ONLY_ACTION_ITEMS_NOTE,
  },
  note_addendum: {
    pending: ALL_ACTION_ITEMS_ADDENDUM,
    rejected: VIEW_ONLY_ACTION_ITEMS_ADDENDUM,
    resubmitted: ALL_ACTION_ITEMS_ADDENDUM,
    signed: VIEW_ONLY_ACTION_ITEMS_ADDENDUM,
  },
} as const satisfies Record<CosignatureDocumentType, Record<CosignatureStatus, ActionItem[]>>;

export const URGENCY_THRESHOLD = 3;
